export default __webpack_public_path__ + "static/media/servicosp1.1be28aa7.jpg";